<template>
    <div class="animated fadeIn">
        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image contact-us-splash" v-if="!isMobile()">
                                        <img alt="Contact us" src="./assets/contact-us.svg">
                                    </figure>
                                    <figure class="image contact-us-splash mobile-screen" v-else>
                                        <img alt="Contact us" src="./assets/contact-us.svg">
                                    </figure>
                                </div>
                            </div>

                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('contact:contact_us.subtitle') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('contact:contact_us.title') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="columns">
                <div class="column intro-text content small-container">
                    <p class="is-size-6 small-container uptin-text-center uptin-text-center">
                        {{ $t('contact:contact_us.description') }}
                    </p>
                </div>
            </div>
        </section>

        <!-- Contact form section -->
        <section class="section">
            <div class="container">
                <div class="columns contact">
                    <div class="column is-4-tablet">
                        <div class="columns is-centered is-mobile">
                            <div class="column contact-information">
                                <div class="content">
                                    <h4 style="font-family: IRANsans">
                                      {{ $t('contact:contact_us.info') }}
                                    </h4>
                                    <ob-address/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="columns is-centered is-mobile">
                            <div class="column contact-message padding-bottom-2x-mobile">
                                <div class="content">
                                    <h4 class="padding-bottom-2x" style="font-family: IRANsans">
                                        {{ $t('contact:contact_us.message') }}
                                    </h4>
                                    <ob-message/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">

    .contact {
        @media(max-width: 768px) {
            display: flex;
            flex-direction: column-reverse;
        }
    }

    .contact-information {
        max-width: 250px;
    }

    .contact-message {
        max-width: 750px;
    }

    .contact-us-splash {
        max-width: 400px;
        min-width: 400px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }


</style>

<script>
    import ObMailbox from "./components/mailbox";
    import ObAddress from "./components/address";
    import ObMessage from "./components/message";
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"

    export default {
        name: 'uptin-contact-us',
        components: {
            ObMessage,
            ObAddress,
            ObMailbox,
            PayAsYouGo
        },

        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
                }
        }

    }
</script>
